import "./index.css";
import GdnAdTemplate from "../GdnAdTemplate";

/**
 * Google Display Network — 970×90 leaderboard (rendered @2× = 1940×180).
 * Stacked logo on the left, title + subtitle on the right; shared body in
 * ../GdnAdTemplate.
 */
const Leaderboard970Ads = ({id, zoom}) => <GdnAdTemplate id={id} zoom={zoom} variant="stacked" />;

export default Leaderboard970Ads;
